module.exports = __webpack_public_path__ + "static/media/greenCircle.ec47a9f2.svg";